import { WindIcon } from "components/wind-icon"
import initSwellIcons from "components/swell-icon"
import Units from "utils/units" // eslint-disable-line import/no-named-as-default

function ReplacePlugin($pool) {
  return function run(eventName, payload) {
    if (eventName !== "Table:replaceTable") return

    const { tableName, newTableName } = payload

    WindIcon.init(payload.tables[newTableName], {})
    initSwellIcons(payload.tables[newTableName], Units)

    $pool.push("Table:replaceTable::mutate", () => {
      payload.tables[tableName].replaceWith(payload.tables[newTableName])
    })
  }
}

export default ReplacePlugin
